import React, { useContext, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import UsersContext from "../Context/UsersContext";
import Statistic from "./Statistic";
import FinisherStats from "../Components/FinisherStats";
import DeliveryStats from "../Components/DeliveryStats";
import DeliveryImpact from "../Components/DeliveryImpact";

// Mock components for demonstration - replace with your actual components
const OverStatistic = () => {
  return (
    <div className="">
      <Statistic />
    </div>
  );
};

const FarmerFninsh = () => {
  const { farmers } = useContext(UsersContext);
  return (
    <div className="">
      <FinisherStats users={farmers} />
    </div>
  );
};

const DeliveryPerfomance = () => {
  const { farmers } = useContext(UsersContext);
  return (
    <div className="">
      <DeliveryStats users={farmers} />
    </div>
  );
};

const DeliveryImpacts = () => {
  const { farmers } = useContext(UsersContext);
  return (
    <div className="">
      <DeliveryImpact users={farmers} />
    </div>
  );
};

export default function FarmerSettings() {
  const [activeSection, setActiveSection] = useState("Overall Insights");

  const sidebarItems = [
    { name: "Overall Insights", component: OverStatistic },
    { name: "Finishers Dashboard", component: FarmerFninsh },
    { name: "Delivery Perfomance", component: DeliveryPerfomance },
    { name: "Delivery Impact", component: DeliveryImpacts },
  ];

  const renderActiveComponent = () => {
    const activeItem = sidebarItems.find((item) => item.name === activeSection);
    const Component = activeItem?.component || OverStatistic;
    return <Component />;
  };

  return (
    <>
      <motion.div
        className="flex flex-col min-h-screen md:flex-row"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.5 }}
      >
        {/* Sidebar - Horizontal on mobile, vertical on desktop */}
        <motion.div
          className="w-full p-2 border-b border-gray-300 dark:border-gray-500 00 md:border-b-0 md:border-r md:w-60"
          initial={{ x: -100, opacity: 0 }}
          animate={{ x: 0, opacity: 1 }}
          transition={{ duration: 0.6, delay: 0.2 }}
        >
          <motion.h1
            className="mb-4 text-xl font-bold text-center text-gray-800 md:mb-8 md:text-2xl dark:text-gray-300 md:text-left"
            initial={{ y: -20, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.5, delay: 0.3 }}
          >
            Last-Mile Impact Dashboard
          </motion.h1>

          {/* Navigation Items - Horizontal on mobile, vertical on desktop */}
          <nav className="flex flex-row justify-between pb-2 space-x-2 overflow-x-auto md:flex-col md:space-x-0 md:space-y-1 md:overflow-x-visible md:pb-0">
            {sidebarItems.map((item, index) => (
              <motion.div
                key={item.name}
                className={`px-3 py-2 text-sm rounded-lg cursor-pointer transition-all duration-200 relative overflow-hidden whitespace-nowrap flex-shrink-0 md:flex-shrink ${
                  activeSection === item.name
                    ? "bg-green-600 text-white shadow-md"
                    : "text-gray-600 dark:text-gray-300 dark:hover:bg-gray-700 hover:text-green-600 hover:bg-gray-100"
                }`}
                onClick={() => setActiveSection(item.name)}
                initial={{ x: -50, opacity: 0 }}
                animate={{ x: 0, opacity: 1 }}
                transition={{ duration: 0.4, delay: 0.1 * index }}
                whileHover={{
                  scale: 1.02,
                  transition: { duration: 0.2 },
                }}
                whileTap={{ scale: 0.98 }}
              >
                {/* Active indicator */}
                {activeSection === item.name && (
                  <motion.div
                    className="absolute inset-0 bg-green-600 rounded-lg"
                    layoutId="activeTab"
                    initial={false}
                    transition={{ type: "spring", stiffness: 500, damping: 30 }}
                  />
                )}

                {/* Text content */}
                <span className="relative z-10 font-medium">{item.name}</span>
              </motion.div>
            ))}
          </nav>
        </motion.div>

        {/* Main Content */}
        <motion.div
          className="flex-1 py-8 md:p-2 h-[900px] overflow-y-auto"
          initial={{ x: 100, opacity: 0 }}
          animate={{ x: 0, opacity: 1 }}
          transition={{ duration: 0.6, delay: 0.4 }}
        >
          <div className="w-full ">
            <AnimatePresence mode="wait">
              <motion.div
                key={activeSection}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: -20 }}
                transition={{ duration: 0.3 }}
              >
                {renderActiveComponent()}
              </motion.div>
            </AnimatePresence>
          </div>
        </motion.div>
      </motion.div>
    </>
  );
}
